import React, {useContext, useEffect, useState} from "react";
import {BottomNavigation, BottomNavigationAction, Button, Grid} from "@mui/material";
import {useHistory} from "react-router";
import Authorize from "../../routes/authorize";
import {clearToken} from "@api/token";
import NavigationAppBar from "./NavigationAppBar";
import {useTheme} from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import {SUPER_ADMIN} from "@main/constants";
import {RoleContext} from "@hoc/role";

export const Navigation = () => {
    const [value, setValue] = useState(0);
    const history = useHistory();
    const theme = useTheme();
    const {role} = useContext(RoleContext);
    const md = useMediaQuery(theme.breakpoints.up('md'));
    const [autorize, setAutorize] = useState(Authorize)

    useEffect(() => {
        if (role !== SUPER_ADMIN) {
            setAutorize(autorize.filter(({label}) => label !== 'test'))
        }
    }, [])

    const handleChange = (newValue) => {
        const element = autorize.find((obj, index) => index === newValue)
        history.push(element.path)
    };

    const logout = () => {
        clearToken()
        history.push("/signin")
    }

    useEffect(() => {
        const index = autorize.map((data) => data.path).findIndex(path => path === history.location.pathname);
        let delay = 0
        if(role !== SUPER_ADMIN){
            delay = 1
        }
        setValue(index-delay);
    }, [history.location.pathname])

    return (
        <>
            {md ? (
                <Grid container spacing={10}>
                    <Grid item xs={10}>
                        <BottomNavigation
                            showLabels
                            value={value}
                            onChange={(event, newValue) => {
                                handleChange(newValue);
                            }}
                        >
                            {autorize.filter((obj) => obj.label).map((obj, index) => {
                                return (<BottomNavigationAction key={index}
                                                                selected={true}
                                                                id="nav-button"
                                                                label={obj.label}
                                                                icon={React.createElement(obj.icon, {})}></BottomNavigationAction>)
                            })}
                        </BottomNavigation>
                    </Grid>
                    <Grid item md={2}>
                        <Button style={{marginTop: "10px"}} variant="contained" onClick={logout}>Logout</Button>
                    </Grid>
                </Grid>
            ) : (
                <NavigationAppBar handleChange={handleChange} logout={logout}/>
            )}
        </>
    );
};
